export default "/images/vendor/@coreui/icons/svg/flag/cif-uz.svg?38f7444e91810807ba0ba488f70ef949";